<template>
  <div id="print">
    <iframe
      id="printIframe"
      :src="imgUrl"
      frameborder="0"
      width="100%" height="100%"
      @load="resize()"
    />
  </div>
</template>

<script>
const fileTypeMap = {
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
  ppt: 'application/pdf',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  png: 'image/png',
  gif: 'image/gif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  txt: 'text/plain'
}
import { requestDownLoadFilePrint as YuLan } from '../../api/counsel.js'
export default {
  name: 'print',
  data() {
    return {
      imgUrl: '', //图片路径
      sheetNames: null, //从数据中获取到的sheet页数组
      imgType: ['jpg', 'jpeg', 'png', 'pdf']
    }
  },
  methods: {
    // 预览文件
    look(param) {
      let fileType = 'png'
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        if (this.imgType.includes(fileType)) {
          //Image PDF
          YuLan({ Id: param }).then((res) => {
            if (res.data.type.includes('application/json') && res.data.type) {
              this.handlerResponseError(res.data)
            } else {
              const blob = new Blob([res.data], { type })
              this.imgUrl = this.getObjectURL(blob)
            }
          })
          // } else if (fileType === 'doc' || fileType === 'docx') {
        } else {
          this.$message.error('不支持此文件预览')
        }
      } else {
        this.$message.error('不支持此文件预览')
      }
    },
    handlerResponseError(data) {
      const _this = this
      const fileReader = new FileReader()
      fileReader.onload = function () {
        try {
          const jsonData = JSON.parse(fileReader.result) // 说明是普通对象数据，后台转换失败
          if (
            jsonData.status == '401' ||
            jsonData.status == '402' ||
            jsonData.status == '403'
          ) {
            _this.$message.error(jsonData.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            _this.$router.push('/login')
          } // dosomething……
        } catch (err) {
          // 解析成对象失败，说明是正常的文件流
          console.log('success...')
        }
      }
      fileReader.readAsText(data)
    },
    handlerError(data) {
      let enc = new TextDecoder('utf-8')
      var res = enc.decode(new Uint8Array(data))
      var jsonData = JSON.parse(res)
      if (
        jsonData.status == '401' ||
        jsonData.status == '402' ||
        jsonData.status == '403'
      ) {
        this.$message.error(jsonData.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      }
      // this.$message.error(enc.decode(new Uint8Array(res.data)))
    },
    getDownLoadFile(blobFile, contenttype, row) {
      let downloadBolb = null
      let fileType = row.ftype
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = null
      if (fileType) {
        type = fileTypeMap[fileType]
        downloadBolb = new Blob([blobFile], {
          type: type
        })
        // 下载文件
        this.a(downloadBolb, row.name + '.' + fileType)
        return downloadBolb
      }
    },
    getObjectURL(file) {
      let url = null
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file)
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {}
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {}
      }
      return url
    },
    resize() {
      const iframeEle = document.getElementById('printIframe');
      const idoc = iframeEle.contentWindow.document;
      const img = idoc.getElementsByTagName('img')[0];
      if (img) {
        //居中显示就是这两行，就是用了弹性盒，清空margin、padding是因为不清空会有滚动条
        const body = idoc.getElementsByTagName('body')[0];
        body.setAttribute('style', 'margin:0; padding:0; display:flex; align-items:flex-start;; justify-content:center; height:100%;');
        //下面是大小自适应
        const curWidth = img.width;
        const curHeight = img.height;
        const maxWidth = iframeEle.clientWidth;
        const maxHeight = iframeEle.clientHeight;
        if (curWidth >= maxWidth) {
          img.width = maxWidth;
          const zoomTimes = curWidth / maxWidth;
          img.height = curHeight / zoomTimes;
        }
        const curWidth1 = img.width;
        const curHeight1 = img.height;
        if (curHeight1 >= maxHeight) {
          img.height = maxHeight;
          const zoomTimes = curHeight1 / maxHeight;
          img.width = curWidth1 / zoomTimes;
        }
      }
    },
  },
  created() {
    this.look(this.$route.query.id)
  },

}


</script>

<style>
#print{
  width: 100%;
  height: 100%;
}

</style>